import React from 'react';
import { Star } from 'lucide-react';
import { FadeIn } from './FadeIn';
interface Testimonial {
  quote: string;
  author: string;
  meta: string;
  initials: string;
  avatar?: string;
}
const testimonials: Testimonial[] = [{
  quote: 'I tried NoFap 6 times. The book did not ask me to hold on to anything. Just to understand something. On day 7 I realized I had not thought about it. No effort. No battle.',
  author: 'Brandon T.',
  meta: '28, Chicago',
  initials: 'BT',
  avatar: 'https://cdn.magicpatterns.com/uploads/vtXAfiiWTw2P4xnL83d9Tf/BRANDON_T.,_28,_CHICAGO.png'
}, {
  quote: 'I have been dealing with this for 11 years. I thought it was part of who I am. Turns out it was not. Chapter 4 was the exact moment something changed.',
  author: 'Jason M.',
  meta: '37, Austin',
  initials: 'JM',
  avatar: 'https://cdn.magicpatterns.com/uploads/312Lzw1kfLnC1JxYoVsjEc/JASON_M.,_37,_AUSTIN.png'
}, {
  quote: 'My relationship was broken on the inside even though it looked fine on the outside. Three weeks after finishing the book my partner asked me what had changed. I did not know how to explain it.',
  author: 'Kevin R.',
  meta: '31, New York',
  initials: 'KR',
  avatar: 'https://cdn.magicpatterns.com/uploads/drK1y1Dp2gq375PZPgNwL7/KEVIN_R.,_31,_NEW_YORK.png'
}, {
  quote: 'I am not fighting urges every morning anymore. There is nothing to fight. That is the part nobody tells you — the goal is not to become stronger. The goal is to make the enemy disappear.',
  author: 'Austin D.',
  meta: '41, Seattle',
  initials: 'AD',
  avatar: 'https://cdn.magicpatterns.com/uploads/51NtimFiLtZwhLgu2oteZt/AUSTIN_D.,_41,_SEATTLE.png'
}];
export const Testimonials: React.FC = () => {
  return <section className="w-full bg-navy text-cream py-14 sm:py-20 mt-12 sm:mt-16" data-id="element-189">
      <div className="max-w-5xl mx-auto px-5 sm:px-6" data-id="element-190">
        <FadeIn data-id="element-191">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif font-bold text-center mb-10 sm:mb-14" data-id="element-192">
            What Other Men Are Saying
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-8" data-id="element-193">
          {testimonials.map((t, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-194">
              <div className="bg-navy-light p-6 sm:p-8 rounded-sm border border-cream/10 h-full flex flex-col" data-id="element-195">
                <div className="flex items-center gap-4 mb-6" data-id="element-196">
                  {t.avatar ? <img src={t.avatar} alt={`Portrait of ${t.author}`} className="w-14 h-14 rounded-full object-cover border-2 border-amber/40 shrink-0" data-id="element-197" /> : <div className="w-14 h-14 rounded-full bg-amber/20 border-2 border-amber/40 flex items-center justify-center shrink-0" aria-hidden="true" data-id="element-198">
                      <span className="font-serif font-bold text-amber text-lg" data-id="element-199">
                        {t.initials}
                      </span>
                    </div>}
                  <div data-id="element-200">
                    <p className="font-sans font-semibold text-cream" data-id="element-201">
                      {t.author}
                    </p>
                    <p className="text-xs font-sans text-cream/50" data-id="element-202">{t.meta}</p>
                  </div>
                </div>
                <div className="flex gap-1 mb-4" data-id="element-203">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-amber text-amber" data-id="element-204" />)}
                </div>
                <p className="text-base sm:text-lg font-serif italic leading-relaxed text-cream/90 flex-grow" data-id="element-205">
                  "{t.quote}"
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};